import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { MandatorModel } from 'src/app/models/management/mandator.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { MandatorTableModel } from 'src/app/models/tables/management/mandator-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MandatorService {

  constructor(private _httpClient: HttpClient) { }

  createMandator(mandatorModel: MandatorModel): Observable<MandatorModel> {
    return this._httpClient.post<MandatorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.mandator.CreateMandatorAsync}`,
      mandatorModel
    );
  }

  deleteMandator(mandatorId: number): Observable<MandatorModel> {
    const params = new HttpParams().set('mandatorId', mandatorId);
    return this._httpClient.delete<MandatorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.mandator.DeleteMandatorAsync}`,
      { params: params }
    );
  }

  deleteSomeMandators(mandatorIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.mandator.DeleteSomeAsync}`,
      mandatorIds
    );
  }

  exportGeneralConsultation(columnSort: string | null, ascendant: boolean, companyId: number): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString()).set('companyId', companyId);
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.mandator.ExportGeneralConsultation}`, null, {
      params,
      responseType: 'blob',
    });
  }

  getMandatorById(mandatorId: number): Observable<MandatorModel> {
    const params = new HttpParams().set('mandatorId', mandatorId);
    return this._httpClient.get<MandatorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.mandator.GetByIdAsync}`,
      { params: params }
    )
  }

  getColumnsForSelection(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.mandator.GetColumnsForSelection}`);
  }

  getMandatorsForSelection(page: number, limit: number, columnSort: string | null, ascendant: boolean, companyId: number): Observable<PagedResponseModel<MandatorTableModel>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('companyId', companyId);
    return this._httpClient.post<PagedResponseModel<MandatorTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.mandator.GetMandatorsForSelectionAsync}`,
      null, { params: params }
    );
  }

  UpdateMandator(mandatorModel: MandatorModel): Observable<MandatorModel> {
    return this._httpClient.put<MandatorModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.mandator.UpdateMandatorAsync}`,
      mandatorModel
    );
  }
}
